import { SimpleGrid, SimpleGridProps } from "@mantine/core"
import { SuspenseWithErrorBoundary } from "./suspense"

interface Props<T> extends SimpleGridProps {
  tileData: T[]
  renderTile: ({ tileData }: { tileData: T }) => React.ReactNode
}

export function TileGrid<T>({ tileData, renderTile, ...props }: Props<T>) {
  return (
    <SimpleGrid
      cols={{ sm: 1, md: 2, xxl: 3, xxxl: 4 }}
      spacing={{ base: "sm", sm: "md" }}
      {...props}
    >
      {tileData.map((data, i) => (
        <SuspenseWithErrorBoundary key={i}>
          {renderTile({ tileData: data })}
        </SuspenseWithErrorBoundary>
      ))}
    </SimpleGrid>
  )
}
